import React from "react"
import {useTranslation} from "react-i18next"
import {twMerge} from "tailwind-merge"

import {LayoutBlock} from "../../components/Layout/LayoutBlock.tsx"
import {useDocumentTitle} from "../../utils/hooks.tsx"
import {CARD_CLASS_NAME} from "./components/cardStyles.ts"
import {CoverageCard} from "./components/CoverageCard.tsx"
import {Header} from "./components/Header.tsx"
import {KpiRow} from "./components/KpiRow.tsx"
import {LatestUpdatesCard} from "./components/LatestUpdatesCard.tsx"
import {LeadDrawer} from "./components/LeadDrawer.tsx"
import {LeadsTable} from "./components/LeadsTable.tsx"
import {PipelineCard} from "./components/PipelineCard.tsx"
import {SalesPeopleCard} from "./components/SalesPeopleCard.tsx"
import {UpdateCenterDrawer} from "./components/UpdateCenterDrawer.tsx"
import {UpdatesChartCard} from "./components/UpdatesChartCard.tsx"
import {KlaraFiltersContext, KlaraFiltersProvider} from "./filters.tsx"

export const KlaraDashboard: React.FC = () => {
  const {t} = useTranslation()

  useDocumentTitle(t("KlaraDashboard_DocumentTitle"))

  return (
    <KlaraFiltersProvider>
      <LayoutBlock
        outerClassName={"grow bg-cr-blue-super-light pixel-units pt-6 pb-18"}
        innerClassName={"flex max-w-[1280px] flex-col gap-4"}
      >
        <Header />
        <div data-region={"kpis"}>
          <KpiRow />
        </div>
        <div
          data-region={"coverage-and-chart"}
          className={twMerge(CARD_CLASS_NAME, "flex flex-wrap items-stretch gap-x-9 gap-y-6 px-6 py-[22px]")}
        >
          <CoverageCard />
          <UpdatesChartCard />
        </div>
        <div data-region={"sales-people"}>
          <SalesPeopleCard />
        </div>
        <div data-region={"pipeline-and-updates"} className={"flex flex-wrap items-stretch gap-4"}>
          <PipelineCard />
          <LatestUpdatesCard />
        </div>
        <div data-region={"leads"}>
          <LeadsTable />
        </div>
      </LayoutBlock>
      <KlaraDrawerHost />
    </KlaraFiltersProvider>
  )
}

// Hosts the dashboard drawers; each drawer reads `drawer` from KlaraFiltersContext.
export const KlaraDrawerHost: React.FC = () => {
  const {drawer, closeDrawer} = KlaraFiltersContext.useContext()

  if (drawer?.kind === "updates") {
    return <UpdateCenterDrawer entryId={drawer.entryId} onClose={closeDrawer} />
  }
  if (drawer?.kind === "lead") {
    return <LeadDrawer dealId={drawer.dealId} onClose={closeDrawer} />
  }

  return null
}
